import axios from "axios";
import React, { useEffect, useState } from "react";
import { showSuccess, showError } from "component/utils/SweetAlert";

const RoomModalForm = ({ mode, roomData, closeModal, onSuccess }) => {
  const [items, setItems] = useState([]);

  const [formData, setFormData] = useState({
    room_id: "",
    item_id: "",
    room_number: "",
    floor: "",
    status: "AVAILABLE",
  });

  /* =============================
     LOAD ITEM HOTEL (TYPE KAMAR)
  ============================== */
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API}/item-hotel`)
      .then((res) => setItems(res.data.data))
      .catch(() => showError("Gagal mengambil data tipe kamar"));
  }, []);

  /* =============================
     SET DATA SAAT EDIT
  ============================== */
  useEffect(() => {
    if (mode === "edit" && roomData) {
      setFormData({
        room_id: roomData.room_id,
        item_id: roomData.item_id,
        room_number: roomData.room_number,
        floor: roomData.floor,
        status: roomData.status,
      });
    }
  }, [mode, roomData]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  /* =============================
     SUBMIT FORM
  ============================== */
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (mode === "add") {
        const response = await axios.post(
          `${process.env.REACT_APP_API}/room`,
          formData
        );
        if (response.status === 201) {
          showSuccess("Room berhasil ditambahkan");
          closeModal();
          onSuccess?.();
        }
      } else {
        const response = await axios.put(
          `${process.env.REACT_APP_API}/room/${formData.room_id}`,
          formData
        );

        if (response.status === 200) {
          showSuccess("Room berhasil diperbarui");
          closeModal();
          onSuccess?.();
        }
      }
    } catch (error) {
      showError(
        error.response?.data?.message ||
          "Terjadi kesalahan saat menyimpan data"
      );
    }
  };

  return (
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">
            {mode === "add" ? "Tambah Room" : "Edit Room"}
          </h5>
          <button className="btn-close" onClick={closeModal}></button>
        </div>

        <div className="modal-body">
          <form onSubmit={handleSubmit}>
            {/* PILIH TYPE KAMAR */}
            <div className="form-group mb-3">
              <label className="form-label">Type Kamar</label>
              <select
                className="form-select"
                name="item_id"
                value={formData.item_id}
                onChange={handleChange}
                required
              >
                <option value="" disabled hidden>-- Pilih Type Kamar --</option>
                {items.map((item) => (
                  <option key={item.item_id} value={item.item_id}>
                    {item.title}
                  </option>
                ))}
              </select>
              {/* {mode === "edit" && (
                <small className="text-muted">
                  Type kamar tidak dapat diubah
                </small>
              )} */}
            </div>

            {/* NOMOR KAMAR */}
            <div className="form-group mb-3">
              <label className="form-label">Nomor Room</label>
              <input
                type="text"
                className="form-control"
                name="room_number"
                value={formData.room_number}
                onChange={handleChange}
                required
              />
            </div>

            {/* FLOOR */}
            <div className="form-group mb-3">
              <label className="form-label">Lantai</label>
              <input
                type="number"
                className="form-control"
                name="floor"
                value={formData.floor}
                onChange={handleChange}
              />
            </div>

            {/* STATUS */}
            <div className="form-group mb-4">
              <label className="form-label">Status</label>
              <select
                className="form-select"
                name="status"
                value={formData.status}
                onChange={handleChange}
              >
                <option value="AVAILABLE">AVAILABLE</option>
                <option value="RESERVED">RESERVED</option>
                <option value="OCCUPIED">OCCUPIED</option>
                <option value="DIRTY">DIRTY</option>
                <option value="MAINTENANCE">MAINTENANCE</option>
              </select>
            </div>

            <button type="submit" className="btn btn-primary w-100">
              {mode === "add" ? "Simpan" : "Update"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RoomModalForm;
